module.exports = __webpack_public_path__ + "img/logo(2).3a473691.png";